import { HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { inject, isDevMode } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  let oktaAuth: OktaAuth = inject(OKTA_AUTH);
  const accessToken = oktaAuth.getAccessToken();

  let url = request.url;
  let headers = request.headers;
  let queryParams = request.params;
  let body = request.body;

  try {
    const isFactorEndpoint = url.includes('Factor');
    const isFactorAuthEndpoint = url.includes('Factor/auth');

    if (accessToken) {
      headers = headers.append('Authorization', 'Bearer ' + accessToken);
    }

    if (isFactorEndpoint) {
      if (!isFactorAuthEndpoint) {
        if (accessToken) {
          // if(!authEndpointExcludes.some((endpoint) => url.includes(endpoint))) {
          //   url = url.replace('Factor', 'Factor/auth');
          // }
        } else {
          url = url.replace('Enable2faEmail', 'SendEmail2fa');
          url = url.replace('Submit2faEmail', 'VerifyEmail2fa');
          url = url.replace('Enable2faSms', 'SendSms2fa');
          url = url.replace('Submit2faSms', 'VerifySms2fa');

          let httpParams = body as HttpParams;
          const newBody = new Map();

          if (
            ['SendSms2fa', 'VerifySms2fa'].some((endpoint) =>
              url.includes(endpoint)
            )
          ) {
            const phone = httpParams.get('phoneNumber');
            httpParams = httpParams.delete('phoneNumber');
            httpParams = httpParams.append('phone', phone ?? '');
          }

          if (
            ['VerifyEmail2fa', 'VerifySms2fa'].some((endpoint) =>
              url.includes(endpoint)
            )
          ) {
            const code = httpParams.get('passCode');
            httpParams = httpParams.delete('passCode');
            httpParams = httpParams.append('code', code ?? '');
          }

          if (
            [
              'SendEmail2fa',
              'VerifyEmail2fa',
              'SendSms2fa',
              'VerifySms2fa',
            ].some((endpoint) => url.includes(endpoint))
          ) {
            for (var key of httpParams.keys()) {
              const value = httpParams.get(key);
              newBody.set(key, value);
            }

            body = Object.fromEntries(newBody);
          }
        }
      }
    }

    request = request.clone({
      url: url,
      headers: headers,
      body: body,
    });
  } catch (error) {}

  return next(request);
};
